<ng-container *ngFor="let faq of faqs; index as i">
  <div class="mb-3">
    <div class="hstack gap-1">
      <lui-avatar color="{{ faq.iconColor }}" [size]="64">
        <mat-icon svgIcon="{{ faq.icon }}"></mat-icon>
      </lui-avatar>
      <span [id]="'faq-section-' + faq.id" class="mat-h3" i18n>{{
        faq.title
      }}</span>
    </div>
    <mat-divider class="mt-2"></mat-divider>
    <ng-container *ngFor="let question of faq.questions; last as last">
      <lui-expansion-panel #panel>
        <lui-expansion-panel-header i18n>
          <div class="hstack justify-content-between">
            <div
              [id]="'faq-section-' + faq.id + '-question-' + question.id"
              class="fw-b"
            >
              {{ question.title }}
            </div>
            <button luiFab size="sm">
              <mat-icon
                [svgIcon]="
                  panel.expanded ? 'chevron_up_thin' : 'chevron_down_thin'
                "
              ></mat-icon>
            </button>
          </div>
        </lui-expansion-panel-header>
        <lui-expansion-panel-content>
          <div class="pb-1_5" [innerHTML]="question.content"></div>
        </lui-expansion-panel-content>
      </lui-expansion-panel>
      <mat-divider *ngIf="!last"></mat-divider>
    </ng-container>
  </div>
</ng-container>
